var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M5.424 10.993a18.515 18.515 0 0 0 8.055 8.054l2.689-2.689c.33-.33.819-.44 1.246-.293 1.37.452 2.848.697 4.364.697.672 0 1.222.55 1.222 1.222v4.265c0 .673-.55 1.223-1.222 1.223C10.3 23.472 1 14.17 1 2.694c0-.672.55-1.222 1.222-1.222H6.5c.672 0 1.222.55 1.222 1.222 0 1.528.245 2.994.697 4.363.134.428.037.905-.306 1.247l-2.689 2.689z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.4f2d8f0bca8c2a99d14a0a847872e9fa.svg";
export { ForwardRef as ReactComponent };